import React from 'react';
import classNames from 'classnames';
import { cancellationPeriodTypeValue } from '~constants/property-field-options';
import { useTranslation } from 'react-i18next';

const CheckInTip = ({ type }) => {
  const { t } = useTranslation();
  const isUntilMoveIn = type === cancellationPeriodTypeValue.UNTIL_MOVE_IN_DAY;
  const isAfterBookingConfirmed = type === cancellationPeriodTypeValue.AFTER_BOOKING_CONFIRMED;

  return (
    <div
      className={classNames('check-in-tip', {
        'check-in-tip--center': isUntilMoveIn,
        'check-in-tip--left': isAfterBookingConfirmed,
      })}
    >
      <div className="check-in-tip__check-in">
        {isAfterBookingConfirmed
          ? t('cms.listing.modal.booking_confirmed.label')
          : t('cms.listing.modal.move_in.label')}
      </div>
      <div
        className={classNames('check-in-tip__triangle', {
          'check-in-tip__triangle--left': isAfterBookingConfirmed,
        })}
      />
      <div
        className={classNames('check-in-tip__check-in-point', {
          'check-in-tip__check-in-point--left': isAfterBookingConfirmed,
        })}
      />
    </div>
  );
};

export default CheckInTip;
